module.exports = __webpack_public_path__ + "static/media/hawthorne_strainer.cb73f91d.png";